"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TemplateModal;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _TemplateItem = _interopRequireDefault(require("./TemplateItem"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-len */

const PlainButton = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "PlainButton",
  class: "pl-p127f5wh"
});
const ExitButton = /*#__PURE__*/(0, _react2.styled)(PlainButton)({
  name: "ExitButton",
  class: "pl-e9ud1mi"
});
const BreakpointButton = /*#__PURE__*/(0, _react2.styled)(PlainButton)({
  name: "BreakpointButton",
  class: "pl-b6h0f7w",
  vars: {
    "b6h0f7w-3": [({
      active
    }) => active ? _intents.default.ux.feedbackNeutral.feedbackColor : _intents.default.ux.box.foregroundColor]
  }
});
const Disclaimer = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Disclaimer",
  class: "pl-d1hjfd0x"
});
const RightSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RightSection",
  class: "pl-r2mta8y"
});
const TopBar = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TopBar",
  class: "pl-tf3mij7"
});
const CarouselModal = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CarouselModal",
  class: "pl-cusbpk1",
  vars: {
    "cusbpk1-0": [({
      open
    }) => open ? 1 : 0],
    "cusbpk1-1": [({
      open
    }) => open ? 'visible' : 'hidden'],
    "cusbpk1-2": [({
      open
    }) => open ? 'initial' : 'none']
  }
});
const Frame = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Frame",
  class: "pl-fhzfecx"
});
const PhoneOutline = /*#__PURE__*/(0, _react2.styled)(Frame)({
  name: "PhoneOutline",
  class: "pl-pyoo3g4"
});

/**
 * TemplateModal component.
 *
 * @param {Object} props React props
 * @param {string} props.modalExitText The modal's exit text
 * @param {string} props.modalPrimaryButtonText The text of the modal's primary button
 * @param {string} props.modalDisclaimerText The modal's disclaimer text
 * @param {obj} props.selectedTemplate The template corresponding to this modal object
 * @param {function} props.exitAction The function triggered to exit the modal
 * @param {array} props.open Whether or not the modal is active and visible
 * @param {boolean} props.hasCustomUrl If the onBoardingUrl needs ['lid', 'vertical', 'id']
 * @returns {React.ReactElement} TemplateModal component
 * @public
 */
function TemplateModal({
  modalExitText = 'Back',
  modalPrimaryButtonText = 'Start with this template',
  modalDisclaimerText = '1 Month Trial',
  selectedTemplate,
  exitAction,
  open
}) {
  const [mobile, setMobile] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(CarouselModal, {
    open: open,
    "data-cy": "template-carousel-modal",
    "aria-modal": open
  }, /*#__PURE__*/_react.default.createElement(TopBar, null, /*#__PURE__*/_react.default.createElement(ExitButton, (0, _extends2.default)({
    onClick: exitAction,
    "data-cy": "exit-button",
    "aria-label": "exit"
  }, _patternLibraryUtils.tracking.create('modal_back', true, true)), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-left"
  }), /*#__PURE__*/_react.default.createElement("span", null, modalExitText)), /*#__PURE__*/_react.default.createElement(BreakpointButton, (0, _extends2.default)({
    active: !mobile,
    onClick: () => setMobile(false),
    "aria-label": selectedTemplate?.desktopViewIconAriaLabel,
    "data-cy": "desktop-view-button"
  }, _patternLibraryUtils.tracking.create('modal_desktop', true, true)), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "desktop"
  })), /*#__PURE__*/_react.default.createElement(BreakpointButton, (0, _extends2.default)({
    active: mobile,
    onClick: () => setMobile(true),
    "aria-label": selectedTemplate?.mobileViewIconAriaLabel,
    "data-cy": "mobile-view-button"
  }, _patternLibraryUtils.tracking.create('modal_mobile', true, true)), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "mobile-phone"
  })), /*#__PURE__*/_react.default.createElement(RightSection, null, /*#__PURE__*/_react.default.createElement(Disclaimer, null, modalDisclaimerText), /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    text: modalPrimaryButtonText,
    href: selectedTemplate?.onboardingUrl,
    design: "primary",
    ariaLabel: "Template Link",
    _name: "modal_start"
  }))), mobile ? /*#__PURE__*/_react.default.createElement(PhoneOutline, null, /*#__PURE__*/_react.default.createElement("iframe", {
    src: selectedTemplate && `https://${selectedTemplate?.templateUrl}`,
    className: "show-frame",
    title: selectedTemplate?.name,
    "data-cy": "mobile-template-iframe"
  })) : /*#__PURE__*/_react.default.createElement(Frame, null, /*#__PURE__*/_react.default.createElement("iframe", {
    src: selectedTemplate && `https://${selectedTemplate?.templateUrl}`,
    className: "show-frame",
    title: selectedTemplate?.name,
    "data-cy": "template-iframe"
  })));
}
TemplateModal.propTypes = {
  modalExitText: _propTypes.default.string,
  modalPrimaryButtonText: _propTypes.default.string,
  modalDisclaimerText: _propTypes.default.string,
  selectedTemplate: _propTypes.default.shape(_TemplateItem.default.propTypes),
  exitAction: _propTypes.default.func,
  open: _propTypes.default.bool,
  hasCustomUrl: _propTypes.default.bool
};